// extracted by mini-css-extract-plugin
export default {"root":"navy-modal_root__jS6di","noLongPress":"navy-modal_noLongPress__c7yPn"};